export const ChannelDefaults = {
	"phone": {
		"title": "Phone",
		"icon": "phone.svg",
		"type": "phone"
	},
	"callback": {
		"title": "Callback Request",
		"icon": "callback.svg",
		"type": "callback"
	},
	"webchat": {
		"title": "Web Chat",
		"icon": "webchat.svg",
		"type": "webchat"
	},
	"video": {
		"title": "Video Chat",
		"icon": "video.svg",
		"type": "video"
	},
	"email": {
		"title": "Email",
		"icon": "email.svg",
		"type": "email"
	},
	"sms": {
		"title": "SMS",
		"icon": "sms.svg",
		"type": "sms"
	},
	"whatsapp": {
		"title": "WhatsApp",
		"icon": "whatsApp.svg",
		"type": "whatsapp"
	},
	"telegram": {
		"title": "Telegram",
		"icon": "telegram.svg",
		"type": "telegram"
	},
	"viber": { // Keep type "viber" for backwards compatibility with chat scripts created with older than 24Q1 Configurator
		"title": "Viber",
		"icon": "viber.svg",
		"type": "viber"
	},
	"messenger": {
		"title": "Messenger",
		"icon": "messenger.svg",
		"type": "messenger"
	},
	"viber-chatbot": {
		"title": "Viber Chatbot",
		"icon": "viber.svg",
		"type": "viber-chatbot",
	},
	"viber-business-messages": {
		"title": "Viber Business Messages",
		"icon": "viber.svg",
		"type": "viber-business-messages",
	},
	"custom": {
		"type": "custom" // Just a stub. Other properties come from chat script.
	}	
};